<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showCreateStoreSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'840px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div class="sidebar-header-title">{{(storeId > 0) ? 'Update Store' : 'Create Store'}}</div>
            <div class="sidebar-header-sub-title">{{subTitle}}</div>
        </div>
    </ng-template>

    <div class="bx-pager bx-default-pager">
        <div class="bx-pager-item active">
            <a class="bx-pager-link " data-slide-index="0">Choose Options</a>
            <div class="arrow">

            </div>
        </div>
        <div class="bx-pager-item" [class.active]="activeMenuTab === menuTab.Details" (click)="changeActiveMenuTab(menuTab.Details)">
            <a class="bx-pager-link" data-slide-index="1">Details</a>
            <div class="arrow">

            </div>
        </div>
        <div class="bx-pager-item"
             [class.active]="(activeMenuTab === menuTab.Products)" (click)="changeActiveMenuTab(menuTab.Products)">
            <a class="bx-pager-link" data-slide-index="2">Products</a>
            <div class="arrow">

            </div>
        </div>
        <div class="bx-pager-item" [class.active]="activeMenuTab === menuTab.Employees" (click)="changeActiveMenuTab(menuTab.Employees)">
            <a class="bx-pager-link" data-slide-index="3">Employees</a>
            <div class="arrow">

            </div>
        </div>
        <div class="bx-pager-item" [class.active]="activeMenuTab === menuTab.StoreHours" (click)="changeActiveMenuTab(menuTab.StoreHours)">
            <a class="bx-pager-link" data-slide-index="3">Store Hours</a>
            <div class="arrow">

            </div>
        </div>
        <div class="bx-pager-item" [class.active]="activeMenuTab === menuTab.Handoff" (click)="changeActiveMenuTab(menuTab.Handoff)">
            <a class="bx-pager-link" data-slide-index="3">Handoff</a>
            <div class="arrow">

            </div>
        </div>
        <div class="bx-pager-item" [class.active]="activeMenuTab === menuTab.LegalDocs" (click)="changeActiveMenuTab(menuTab.LegalDocs)">
            <a class="bx-pager-link" data-slide-index="3">Legal Docs</a>
        </div>
    </div>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading" style="margin: 0 -14px;">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 237px)'}"
                       [styleClass]="'app-scrollpanel'">
            <div *ngIf="activeMenuTab === menuTab.ChooseOptions" class="p-4">
                <div class="add-store-choose-option-title">Start from scratch</div>
                <div class="flex flex-row">
                    <div class="add-store-block" (click)="nextCreateStore(menuTab.Details, 'Start from scratch')">
                        <img src="/XpressApp/assets/images/store/add-plus-circle.svg" />
                        <div class="add-store-block__title">Create Store</div>
                    </div>
                </div>

                <div class="add-store-choose-option-title">Use template</div>
                <div class="flex flex-row">
                    <div class="add-store-block">
                        <img src="/XpressApp/assets/images/store/add-plus-circle.svg" />
                        <div class="add-store-block__title">Store 1</div>
                    </div>
                    <div class="add-store-block">
                        <img src="/XpressApp/assets/images/store/add-plus-circle.svg" />
                        <div class="add-store-block__title">Store 2</div>
                    </div>
                    <div class="add-store-block">
                        <img src="/XpressApp/assets/images/store/add-plus-circle.svg" />
                        <div class="add-store-block__title">Store 3</div>
                    </div>
                </div>

                <div class="add-store-choose-option-title">Bulk Upload</div>
                <div class="flex flex-row">
                    <div class="add-store-block">
                        <img src="/XpressApp/assets/images/product/csv.svg" />
                        <div class="add-store-block__title">Upload CSV</div>
                    </div>
                    <div class="add-store-download-csv-block">
                        <img src="/XpressApp/assets/images/product/csv.svg" />
                        <div class="add-store-download-csv__link-title">Download CSV Template</div>
                    </div>
                </div>
            </div>

            <div *ngIf="activeMenuTab === menuTab.Details" class="p-4">
                <div class="add-store-field">
                    <div class="add-store-field__label">Store Name</div>
                    <input type="text" [(ngModel)]="store.Name" [class]="(store.NameIsEmpty) ? 'ng-invalid ng-dirty' : ''"
                           placeholder="Published Name" pInputText (input)="validateField()" />
                    <div class="add-store-field__error-message" *ngIf="store.NameIsEmpty">Required</div>
                </div>

                <div class="flex flex-row">
                    <div class="col-6 p-0 pr-4">
                        <div class="add-store-field">
                            <div class="add-store-field__label">Store Address</div>
                            <input type="text" [(ngModel)]="store.AddressDetails" [class]="(store.AddressDetailsIsEmpty) ? 'ng-invalid ng-dirty' : ''"
                                   placeholder="Unit/Floor" pInputText (input)="validateField()" />
                            <div class="add-store-field__error-message" *ngIf="store.AddressDetailsIsEmpty">Required</div>
                        </div>
                    </div>
                </div>

                <div class="add-store-field">
                    <p-autoComplete [(ngModel)]="store.Address"
                                    [suggestions]="addresses"
                                    (completeMethod)="search($event)"
                                    placeholder="Street Address"
                                    (click)="geocodeClick()"
                                    (ngModelChange)="validateField()"
                                    [class]="(store.AddressIsEmpty) ? 'ng-invalid ng-dirty' : ''"
                                    [inputStyle]="{'width': '770px', 'padding': '10px 15px'}">
                    </p-autoComplete>
                    <div class="add-store-field__error-message" *ngIf="store.AddressIsEmpty">Required</div>
                </div>

                <div class="flex flex-row">
                    <div class="col-6 p-0 pr-4">
                        <div class="add-store-field">
                            <input type="text" [(ngModel)]="store.City" [class]="(store.CityIsEmpty) ? 'ng-invalid ng-dirty' : ''"
                                   placeholder="City" pInputText (input)="validateField()" />
                            <div class="add-store-field__error-message" *ngIf="store.CityIsEmpty">Required</div>
                        </div>
                    </div>
                    <div class="col-6 p-0 pl-4">
                        <div class="add-store-field">
                            <input type="text" [(ngModel)]="store.PostalCode" [class]="(store.PostalCodeIsEmpty) ? 'ng-invalid ng-dirty' : ''"
                                   placeholder="Postal Code" pInputText (input)="validateField()" />
                            <div class="add-store-field__error-message" *ngIf="store.PostalCodeIsEmpty">Required</div>
                        </div>
                    </div>
                </div>

                <div class="add-store-field">
                    <div class="add-store-field__label">
                        Store Photo
                    </div>
                    <div class="flex flex-row">
                        <div class="store-upload-img-block" *ngIf="store.ImageUrl">
                            <img src="{{store.ImageUrl}}" class="store-upload-img" />
                        </div>

                        <div class="store-upload-img-block">
                            <input id="idImgInput"
                                   type="file"
                                   accept="image/*"
                                   style="display: none"
                                   (change)="handleImageChange($event, 'StoreImage')" required />
                            <div class="store-upload-img__add-link" (click)="handleImageClick('idImgInput')">
                                <img src="/XpressApp/assets/images/store/add-plus-circle.svg" />
                                <div class="store-upload-img__add-title">
                                    Add
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="activeMenuTab === menuTab.Employees" class="p-4">
                <div class="add-store-search-employee-block">
                    <div class="add-store-field__label">Store Manager</div>
                    <div>
                        <p-autoComplete [suggestions]="merchantEmployees"
                                        (completeMethod)="getMerchantUsers($event, merchantUserRolesEnum.StoreManager)"
                                        placeholder="Search employee name..."
                                        field="UserName"
                                        (onSelect)="clickMerchantEmployee($event, merchantUserRolesEnum.StoreManager)"
                                        [inputStyle]="{'width': '280px', 'padding': '10px 15px'}">
                        </p-autoComplete>
                    </div>
                    <div class="flex flex-row">
                        <div class="store-employee-block" *ngFor="let employee of arrayEmployeeManagers; let i = index;">
                            <div class="store-employee-block__img-block">
                                <i class="pi pi-times store-remove-employee" (click)="deleteMerchantEmployee(i, merchantUserRolesEnum.StoreManager)"></i>
                                <img src="{{employee.ImageUrl}}" />
                            </div>
                            <div class="store-employee-block__name">
                                {{employee.UserName}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="add-store-search-employee-block">
                    <div class="add-store-field__label">Cashiers</div>
                    <div>
                        <p-autoComplete [suggestions]="merchantEmployees"
                                        (completeMethod)="getMerchantUsers($event, merchantUserRolesEnum.Cashier)"
                                        placeholder="Search employee name..."
                                        field="UserName"
                                        (onSelect)="clickMerchantEmployee($event, merchantUserRolesEnum.Cashier)"
                                        [inputStyle]="{'width': '280px', 'padding': '10px 15px'}">
                        </p-autoComplete>
                    </div>
                    <div class="flex flex-row">
                        <div class="store-employee-block" *ngFor="let employee of arrayEmployeeCashiers; let i = index;">
                            <div class="store-employee-block__img-block">
                                <i class="pi pi-times store-remove-employee" (click)="deleteMerchantEmployee(i, merchantUserRolesEnum.Cashier)"></i>
                                <img src="{{employee.ImageUrl}}" />
                            </div>
                            <div class="store-employee-block__name">
                                {{employee.UserName}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="add-store-search-employee-block">
                    <div class="add-store-field__label">Packers</div>
                    <div>
                        <p-autoComplete [suggestions]="merchantEmployees"
                                        (completeMethod)="getMerchantUsers($event, merchantUserRolesEnum.Dispatcher)"
                                        placeholder="Search employee name..."
                                        field="UserName"
                                        (onSelect)="clickMerchantEmployee($event, merchantUserRolesEnum.Dispatcher)"
                                        [inputStyle]="{'width': '280px', 'padding': '10px 15px'}">
                        </p-autoComplete>
                    </div>
                    <div class="flex flex-row">
                        <div class="store-employee-block" *ngFor="let employee of arrayEmployeePackers; let i = index;">
                            <div class="store-employee-block__img-block">
                                <i class="pi pi-times store-remove-employee" (click)="deleteMerchantEmployee(i, merchantUserRolesEnum.Dispatcher)"></i>
                                <img src="{{employee.ImageUrl}}" />
                            </div>
                            <div class="store-employee-block__name">
                                {{employee.UserName}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="activeMenuTab === menuTab.StoreHours">
                <partner-mart-locations-hours [operationHours]="operationHours"
                                              [specialHours]="specialHours"></partner-mart-locations-hours>
            </div>

            <div *ngIf="activeMenuTab === menuTab.Handoff">

                <div class="card">
                    <p-accordion [activeIndex]="0">
                        <p-accordionTab>
                            <ng-template pTemplate="header">
                                <div>
                                    <span class="accordion-handoff-header-titile">Delivery details</span>
                                    <br />
                                    <span class="accordion-handoff-header-sub-titile">Please indicate where the delivery driver should pick up orders from</span>
                                </div>
                            </ng-template>

                            <div class="add-store-field">
                                <div class="add-store-field__label">Street Address</div>
                                <p-autoComplete [(ngModel)]="store.PickupAddress"
                                                [suggestions]="addresses"
                                                (completeMethod)="search($event)"
                                                placeholder="Street Address"
                                                (click)="geocodeClick()"
                                                (ngModelChange)="validateField()"
                                                [class]="(store.PickupAddress) ? 'ng-invalid ng-dirty' : ''"
                                                [inputStyle]="{'width': '770px', 'padding': '10px 15px'}">
                                </p-autoComplete>
                                <div class="add-store-field__error-message" *ngIf="!store.PickupAddress">Required</div>
                            </div>

                            <div class="flex flex-row">
                                <div class="col-6 p-0 pr-4">
                                    <div class="add-store-field">
                                        <div class="add-store-field__label">Location Details</div>
                                        <input type="text" [(ngModel)]="store.PickupTitle" [class]="(!store.PickupTitle) ? 'ng-invalid ng-dirty' : ''"
                                               placeholder="Unit/Floor" pInputText (input)="validateField()" />
                                        <div class="add-store-field__error-message" *ngIf="!store.PickupTitle">Required</div>
                                    </div>
                                </div>
                                <div class="col-6 p-0 pl-4">
                                    <div class="add-store-field">
                                        <div class="add-store-field__label">
                                            <br />
                                        </div>
                                        <p-dropdown placeholder="Location Type" [(ngModel)]="store.LocationTypeId" [options]="locationType"
                                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                                        <div class="add-store-field__error-message" *ngIf="!store.LocationTypeId">Required</div>
                                    </div>
                                </div>
                            </div>

                            <div class="add-store-field">
                                <input type="text" [(ngModel)]="store.PickupAddressDetail" placeholder="Street Address" pInputText />
                                <div class="add-store-field__error-message" *ngIf="!store.PickupAddressDetail">Required</div>
                            </div>

                            <div class="add-store-field">
                                <div class="add-store-field__label">
                                    Delivery Location Photo(s) (sent to driver)
                                </div>
                                <div class="flex flex-row">
                                    <div class="store-upload-img-block" *ngIf="store.PickupImageUrl">
                                        <img src="{{store.PickupImageUrl}}" class="store-upload-img" />
                                    </div>

                                    <div class="store-upload-img-block">
                                        <input id="idImgInput"
                                               type="file"
                                               accept="image/*"
                                               style="display: none"
                                               (change)="handleImageChange($event, 'DeliveryDetails')" required />
                                        <div class="store-upload-img__add-link" (click)="handleImageClick('idImgInput')">
                                            <img src="/XpressApp/assets/images/store/add-plus-circle.svg" />
                                            <div class="store-upload-img__add-title">
                                                Add
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </p-accordionTab>
                    </p-accordion>

                    <!--<div style="margin-top: 28px;">
                <p-accordion>
                    <p-accordionTab>
                        <ng-template pTemplate="header">
                            <div>
                                <span class="accordion-handoff-header-titile">Pick up details</span>
                                <br />
                                <span class="accordion-handoff-header-sub-titile">Please indicate where the delivery driver should pick up orders from</span>
                            </div>
                        </ng-template>

                        <div class="add-store-field">
                            <div class="add-store-field__label">Street Address</div>
                            <p-autoComplete [(ngModel)]="store.PickupAddress"
                                            [suggestions]="addresses"
                                            (completeMethod)="search($event)"
                                            placeholder="Street Address"
                                            (click)="geocodeClick()"
                                            (ngModelChange)="validateField()"
                                            [class]="(store.PickupAddress) ? 'ng-invalid ng-dirty' : ''"
                                            [inputStyle]="{'width': '770px', 'padding': '10px 15px'}">
                            </p-autoComplete>
                            <div class="add-store-field__error-message" *ngIf="store.PickupAddress">Required</div>
                        </div>

                        <div class="flex flex-row">
                            <div class="col-6 p-0 pr-4">
                                <div class="add-store-field">
                                    <div class="add-store-field__label">Location Details</div>
                                    <input type="text" [(ngModel)]="store.PickupTitle" [class]="(store.PickupTitle) ? 'ng-invalid ng-dirty' : ''"
                                           placeholder="Unit/Floor" pInputText (input)="validateField()" />
                                    <div class="add-store-field__error-message" *ngIf="store.PickupTitle">Required</div>
                                </div>
                            </div>
                            <div class="col-6 p-0 pl-4">
                                <div class="add-store-field">
                                    <div class="add-store-field__label">
                                        <br />
                                    </div>
                                    <p-dropdown placeholder="Location Type" [(ngModel)]="store.PickupLocationTypeId" [options]="locationType"
                                                optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                                    <div class="add-store-field__error-message" *ngIf="store.PickupLocationTypeId">Required</div>
                                </div>
                            </div>
                        </div>

                        <div class="add-store-field">
                            <input type="text" [(ngModel)]="store.PickupAddressDetail" placeholder="Street Address" pInputText />
                            <div class="add-store-field__error-message" *ngIf="store.PickupAddressDetail">Required</div>
                        </div>

                        <div class="add-store-field">
                            <div class="add-store-field__label">
                                Pick up Location Photo(s) (sent to driver)
                            </div>
                            <div class="flex flex-row">
                                <div class="store-upload-img-block" *ngIf="store.PickupImageUrl">
                                    <img src="{{store.PickupImageUrl}}" class="store-upload-img" />
                                </div>

                                <div class="store-upload-img-block">
                                    <input id="pickupIdImgInput"
                                           type="file"
                                           accept="image/*"
                                           style="display: none"
                                           (change)="handleImageChange($event, 'PickupDetails')" required />
                                    <div class="store-upload-img__add-link" (click)="handleImageClick('pickupIdImgInput')">
                                        <img src="/XpressApp/assets/images/store/add-plus-circle.svg" />
                                        <div class="store-upload-img__add-title">
                                            Add
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </p-accordionTab>
                </p-accordion>
            </div>-->
                </div>

            </div>

            <div *ngIf="activeMenuTab === menuTab.LegalDocs && !loading" class="p-4">
                <div class="flex flex-row" style="margin: 20px 0px;">
                    <div style="width: 300px" class="store-docs-label">Registered tax withholding agent:</div>
                    <div class="flex flex-row" style="width: 50px">
                        <p-radioButton (onClick)="validateField()" [value]="true" [(ngModel)]="store.RegisteredAgentTax"></p-radioButton>
                        <div style="margin-left: 10px">Yes</div>
                    </div>
                    <div class="flex flex-row" style="width: 50px; margin-left: 20px;">
                        <p-radioButton (onClick)="validateField()" [value]="false" [(ngModel)]="store.RegisteredAgentTax"></p-radioButton>
                        <div style="margin-left: 10px">No</div>
                    </div>
                </div>

                <div class="flex flex-row" style="margin-bottom: 20px;">
                    <div style="width: 300px" class="store-docs-label">BIR Registration Type:</div>
                    <div class="flex flex-row" style="width: 50px">
                        <p-radioButton (onClick)="validateField()" [value]="birRegistrationTypeEnum.VAT" [(ngModel)]="store.BirRegistrationType"></p-radioButton>
                        <div style="margin-left: 10px">VAT</div>
                    </div>
                    <div class="flex flex-row" style="width: 123px; margin-left: 20px;">
                        <p-radioButton (onClick)="validateField()" [value]="birRegistrationTypeEnum.PercentageTax" [(ngModel)]="store.BirRegistrationType"></p-radioButton>
                        <div style="margin-left: 10px">Percentage Tax</div>
                    </div>
                </div>

                <p-accordion [activeIndex]="0">
                    <p-accordionTab [headerStyle]="{'background': '#FFFFFF'}" iconPos="end">
                        <ng-template pTemplate="header">
                            <div class="flex align-items-center">
                                <span [ngClass]="{'store-docs-label-success' : store.BusinessPermitIsFilled }">Business Permit</span>
                                <div *ngIf="store.BusinessPermitIsFilled" style="width: 20px; height: 20px; border-radius: 50%; background-color: #1CBA70; align-items: center; margin-left: 10px;">
                                    <i class="pi pi-check" style="font-size: 0.8rem; font-weight: 600; color: white; margin-left: 20%"></i>
                                </div>                             
                            </div>
                        </ng-template>
                        <div class="flex flex-row">
                            <div style="width: 350px; margin-right: 50px">
                                <div>
                                    <div class="store-docs-label store-docs-label-margin">Issue Date</div>
                                    <p-calendar [maxDate]="today" [selectOtherMonths]="true" (onSelect)="validateField()" [(ngModel)]="store.BusinessPermitDocumentIssueDate" placeholder="mm/dd/yyyy"></p-calendar>
                                </div>
                                <div>
                                    <div class="store-docs-label store-docs-label-margin">Expiration Date</div>
                                    <p-calendar [minDate]="today" [selectOtherMonths]="true" (onSelect)="validateField()" [(ngModel)]="store.BusinessPermitDocumentExpirationDate" placeholder="mm/dd/yyyy"></p-calendar>
                                </div>
                                <div>
                                    <div class="store-docs-label store-docs-label-margin">Document Number</div>
                                    <input (input)="validateField()" [(ngModel)]="store.BusinessPermitDocumentNumber" type="text" pInputText placeholder="Enter here" />
                                </div>
                            </div>
                            <div>
                                <div class="store-docs-label store-docs-label-margin">Document Upload</div>
                                <div class="flex flex-row">
                                    <p-button (click)="handleImageClick('BusinessPermitImgInput')" [style]="{'background': '#F2F5F7', 'border-color': '#0040604D', 'color': '#333333', 'opacity': '0.5', 'width': '230px', 'height': '42px' }">Upload file</p-button>
                                    <button (click)="handleImageClick('BusinessPermitImgInput')" pButton type="button" class="p-button-text" icon="pi pi-upload"></button>
                                    <input id="BusinessPermitImgInput"
                                           type="file"
                                           accept="image/*"
                                           style="display: none"
                                           (change)="handleImageChange($event, 'BusinessPermitDocument')" />
                                </div>
                                <div *ngIf="store.BusinessPermitDocumentImageUrl" style="margin-top: 20px;">
                                    <p-image [src]="store.BusinessPermitDocumentImageUrl" alt="Image" width="250" [preview]="true"></p-image>
                                </div>
                            </div>
                        </div>
                    </p-accordionTab>
                    <p-accordionTab [headerStyle]="{'background': '#FFFFFF'}" iconPos="end">
                        <ng-template pTemplate="header">
                            <div class="flex align-items-center">
                                <span [ngClass]="{'store-docs-label-success' : store.BIR2303IsFilled }">BIR 2303</span>
                                <div *ngIf="store.BIR2303IsFilled" style="width: 20px; height: 20px; border-radius: 50%; background-color: #1CBA70; align-items: center; margin-left: 10px;">
                                    <i class="pi pi-check" style="font-size: 0.8rem; font-weight: 600; color: white; margin-left: 20%"></i>
                                </div>
                            </div>
                        </ng-template>
                        <div class="flex flex-row">
                            <div style="width: 350px; margin-right: 50px">
                                <div>
                                    <div class="store-docs-label store-docs-label-margin">Issue Date</div>
                                    <p-calendar [maxDate]="today" [selectOtherMonths]="true" (onSelect)="validateField()" [(ngModel)]="store.BIR2303DocumentIssueDate" placeholder="mm/dd/yyyy"></p-calendar>
                                </div>
                                <div>
                                    <div class="store-docs-label store-docs-label-margin">Expiration Date</div>
                                    <p-calendar [minDate]="today" [selectOtherMonths]="true" (onSelect)="validateField()" [(ngModel)]="store.BIR2303DocumentExpirationDate" placeholder="mm/dd/yyyy"></p-calendar>
                                </div>
                                <div>
                                    <div class="store-docs-label store-docs-label-margin">Document Number</div>
                                    <input (input)="validateField()" [(ngModel)]="store.BIR2303DocumentNumber" type="text" pInputText placeholder="Enter here" />
                                </div>
                            </div>
                            <div>
                                <div class="store-docs-label store-docs-label-margin">Document Upload</div>
                                <div class="flex flex-row">
                                    <p-button (click)="handleImageClick('BIRImageClick')" [style]="{'background': '#F2F5F7', 'border-color': '#0040604D', 'color': '#333333', 'opacity': '0.5', 'width': '230px', 'height': '42px' }">Upload file</p-button>
                                    <button (click)="handleImageClick('BIRImageClick')" pButton type="button" class="p-button-text" icon="pi pi-upload"></button>
                                    <input id="BIRImageClick"
                                           type="file"
                                           accept="image/*"
                                           style="display: none"
                                           (change)="handleImageChange($event, 'BIR2303Document')" />
                                </div>
                                <div *ngIf="store.BIR2303DocumentImageUrl" style="margin-top: 20px;">
                                    <p-image [src]="store.BIR2303DocumentImageUrl" alt="Image" width="250" [preview]="true"></p-image>
                                </div>
                            </div>
                        </div>
                    </p-accordionTab>
                </p-accordion>

            </div>

        </p-scrollPanel>
    </div>

    <div class="flex justify-content-end mrg-10-0px p-4">
        <button class="bluedark-btn" pButton label="Next" (click)="addOrUpdateStore()"></button>
    </div>

</p-sidebar>
